<template>
  <Modal
    :value="open"
    :onClose="close"
    :close="false"
    title="Valor unitário"
    size="small"
    >
    <b-row class="form-group">
      <b-col>
        <Money
          ref="unitValue"
          id="unitValue"
          label="Informe o valor unitário, e em seguida em gravar para continuar.
          O valor unitário será aplicado sobre o próximo item lançado."
          inputClass="form-control input"
          :options="optionMoney"
          v-model="unitValue"
        />
      </b-col>
    </b-row>
    <div class="confirm-buttons">
      <Button type="error" @click="close()">Fechar</Button>
      <Button type="success" @click="save()">Gravar</Button>
    </div>
  </Modal>
</template>

<script>
import { Modal } from '@/components';
import { Button } from '@/components/Form';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import Money from '../Form/InputMoney';

export default {
  name: 'ModalChangeUnitValue',
  mixins: [FormatMixin],
  components: {
    Modal,
    Button,
    Money,
  },
  data() {
    return {
      unitValue: 0,
      optionMoney: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        precision: 2,
        masked: true,
      },
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Function,
      required: true,
    },
    changePriceProduct: {
      type: Function,
      required: true,
    },
  },
  watch: {
    open() {
      if (this.open) {
        this.$nextTick(() => {
          this.$refs.unitValue.$el.querySelector('input').focus();
        });
      }
    },
  },
  mounted() {
    this.getConfigEmissor();
  },
  methods: {
    async save() {
      this.changePriceProduct(this.unitValue);
      this.unitValue = 0;
      return this.close();
    },
    getConfigEmissor() {
      if (window.localStorage.getItem('configurationEmissor')) {
        const configEmissor = JSON.parse(window.localStorage.getItem('configurationEmissor'));
        this.optionMoney.precision = configEmissor.decimalPrice;
      }
    },
  },
};
</script>
